module.exports = "/_next/static/images/proces-besparen-7cc1ae3f1d5e4449ca10e64e2fcad305.svg";